import API_ENV from './API_ENV';
import { sendPost } from '@/utils/request.js';
import * as Sentry from '@sentry/browser';
import { sha } from '@/utils/SHA';

/**
 * 获取cookie
 * @param {String} sKey 获取cookie对应的名字
 * @return {String | Object}
 */
export function getCookie(sKey) {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp(
          '(?:(?:^|.*;)\\s*' +
            encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
            '\\s*\\=\\s*([^;]*).*$)|^.*$',
        ),
        '$1',
      ),
    ) || null
  );
}
/**
 * 解析url参数
 * @param {String} sUrl url链接
 * @return {Object}
 */
export function getUrlkey(sUrl) {
  let params = {},
    arr = sUrl.split('?');
  if (arr.length <= 1) return params;
  arr = arr[1].split('&');
  for (var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split('=');
    params[a[0]] = a[1];
  }
  return params;
}

/**
 * 判断工会头
 */
export function unionFlag() {
  let currentUnionValue;
  const union = getQueryString('union');
  const { hostname, pathname } = window.location;
  if (union) {
    // URI带union参数的判断是工会链接
    return union;
  } else if (/^corp/.test(pathname) && pathname.match(/union\/\w+/g)) {
    // 测试环境http://corp.m.test03.com/union/lifangfang02/user/login
    currentUnionValue = pathname.match(/union\/\w+/g)[0].split('/')[1];
  } else {
    // 正式环境http://www.dbenefit.dongfangfuli.com/bfd_pc/index?union=dbenefit&city=2
    // 测试环境http://union.testzhou.zhouweiwei.qa.psf-dev.com/
    // k8s测试环境http://www.lifangfang02.test01.com/drama_pc/home?city=145&mc=Shows
    // stage环境http://www.rjh.stage.dongfangfuli.com/shop/home?city=145&mc=Shopping

    // if (
    //   (API_ENV === 'test' && /^(?:union)/.test(hostname)) ||
    //   /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(
    //     hostname,
    //   )
    // ) {
    //   currentUnionValue = hostname.split('.')[1];
    // } else {
    //   currentUnionValue = '';
    // }

    if (
      (API_ENV === 'test' &&
        (/^(?:union)/.test(hostname) || hostname.split('.').length > 5)) ||
      /^(?:w{3})\.((?!stage)[A-Za-z1-9]{1}(\w|-)+\.)(stage\.)?(\w+\.)(?=com)/.test(
        // eslint-disable-next-line
        hostname
      )
    ) {
      currentUnionValue = hostname.split('.')[1];
    } else if (
      API_ENV === 'test05' &&
      hostname.split('.')[0].indexOf('www-') === -1
    ) {
      if (hostname.split('.')[1].indexOf('test05') != -1 ) {
        currentUnionValue = hostname.split('.')[0];
      } else {
        currentUnionValue = hostname.split('.')[1];
      }
    } else {
      currentUnionValue = '';
    }

    return currentUnionValue;
  }
}
/**
 * gio埋点
 * @param { String } eventName // 事件名称
 * @param { Object } params // 参数
 */
export function gioClickHandle(eventName, params, type = '') {
  const now = new Date().getTime();
  let newParams = null;
  switch (type) {
  case 'cart':
    newParams = getCartGioParams(eventName, params);
    break;
  default:
    newParams = getGioParams(eventName, params, type);
    break;
  }
  try {
    // eslint-disable-next-line
    gio("track", eventName, newParams);
    const url = `https://api.growingio.com/v3/80a245b29a70c4ad/s2s/cstm?stm=${now}`;
    const postParams = [
      {
        cs1: getCookie('gr_user_id') || 'wjn',
        tm: now,
        t: 'cstm',
        n: eventName,
        var: params,
      }
    ];
    sendPost({ url, data: postParams, baseURL: false, applicationType: true });
  } catch (error) {
    console.log(error);
  }
}

export function getGioParams(eventName, params = {}, type = '') {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie('address')) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  let paramNew = {
    df_platform: 'pc',
    df_source: unionF ? '百福得' : '官网',
    df_prepagename: url ? url : null,
    df_userid: getCookie('unionUserId'),
    df_city: address.cityName,
  };
  switch (eventName) {
  case 'DF_pageView':
    paramNew.df_pagename = '活动页';
    paramNew.df_channle = '节日礼包';
    paramNew.df_enteractivitytime = now;
    break;
  case 'DF_elementClick':
    paramNew.df_channle = '节日礼包';
    paramNew.df_pagename = '活动页';
    if (type === 'channelGio') {
      paramNew.df_source = unionF ? '百福得' : '官网';
      paramNew.df_activitytime = farmatDate(
        new Date(),
        'yyyy.MM.dd HH:mm:ss',
      );
      paramNew.df_cityid = '' + address.cityId;
    } else {
      paramNew.df_activitytime = now;
    }
    break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew, 'gioparamNew');
  return paramNew;
}
/** 购物车 */
export function getCartGioParams(eventName, params = {}) {
  const now = new Date().getTime();
  const address = JSON.parse(getCookie('address')) || {};
  const url = window.parent.location.href;
  const unionF = unionFlag() || sessionStorage.getItem('dffl_union');
  let paramNew = {
    df_platform: 'pc',
    df_source: unionF ? '百福得' : '官网',
    df_prepagename: url ? url : null,
    df_userid: getCookie('unionUserId'),
    df_city: address.cityName,
  };
  switch (eventName) {
  case 'DF_elementClick':
    paramNew.df_platform = 'pc';
    paramNew.df_pagename = '购物车';
    paramNew.df_cityid = '' + address.cityId;
    break;
  }
  paramNew = Object.assign(paramNew, params);
  console.log(paramNew, 'gioparamNew');
  return paramNew;
}

/**
 * 删除cookie
 * @param {String} sKey cookie的名字
 * @param {String} sPath cookie的所在目录
 * @param {String} sDomain cookie的所在域
 * @return {Boolean}
 */
export function removeCookie(sKey, sPath, sDomain) {
  if (!sKey || !hasCookie(sKey)) {
    return false;
  }
  document.cookie =
    encodeURIComponent(sKey) +
    '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
    (sDomain ? '; domain=' + sDomain : '') +
    (sPath ? '; path=' + sPath : '');
  return true;
}

/**
 * 判断某cookie是否存在
 * @param {String} sKey cookie的名字
 * @return {Boolean}
 */
export function hasCookie(sKey) {
  return new RegExp(
    '(?:^|;\\s*)' +
      encodeURIComponent(sKey).replace(/[-.+*]/g, '\\$&') +
      '\\s*\\=',
  ).test(document.cookie);
}

/**
 * 获取cookies
 */
export function cookieKeys() {
  const aKeys = document.cookie
    .replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '')
    .split(/\s*(?:\=[^;]*)?;\s*/);
  for (var nIdx = 0; nIdx < aKeys.length; nIdx++) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }
  return aKeys;
}

/**
 * 获取请求参数名对应的值
 * @param  {String} name 参数名字
 * @return {String}
 */
export function getQueryString(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  const res = window.location.search.substr(1).match(reg);
  if (res !== null) return window.decodeURIComponent(res[2]);
  return '';
}
export function setCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
    return false;
  }
  var sExpires = '';
  if (vEnd) {
    switch (vEnd.constructor) {
    case Number:
      sExpires =
          vEnd === Infinity
            ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT'
            : '; max-age=' + vEnd;
      break;
    case String:
      sExpires = '; expires=' + vEnd;
      break;
    case Date:
      sExpires = '; expires=' + vEnd.toUTCString();
      break;
    }
  }
  document.cookie =
    encodeURIComponent(sKey) +
    '=' +
    encodeURIComponent(sValue) +
    sExpires +
    (sDomain ? '; domain=' + sDomain : '') +
    (sPath ? '; path=' + sPath : '') +
    (bSecure ? '; secure' : '');
  return true;
}

/**
 * 对动态脚本的封装
 * @param {String} url 脚本src地址
 * @param { Function } callback 回调函数
 */

export function loadScript(url, callback) {
  let s = document.createElement('script');
  s.type = 'text/javascript';
  s.charset = 'utf-8';
  s.async = true;
  if (s.readyState) {
    s.onreadystatechange = function() {
      if (/complete|loaded/.test(s.readyState)) {
        s.onreadystatechange = null;
        callback && callback();
      }
    };
  } else {
    s.onload = function() {
      callback && callback();
    };
  }

  s.src = url;
  document.body.appendChild(s);
}

export function delParam(paramKey) {
  var url = window.location.href; //页面url
  var urlParam = window.location.search.substr(1); //页面参数
  var beforeUrl = url.substr(0, url.indexOf('?')); //页面主地址（参数之前地址）
  var nextUrl = '';

  var arr = new Array();
  if (urlParam != '') {
    var urlParamArr = urlParam.split('&'); //将参数按照&符分成数组
    for (var i = 0; i < urlParamArr.length; i++) {
      var paramArr = urlParamArr[i].split('='); //将参数键，值拆开
      //如果键雨要删除的不一致，则加入到参数中
      if (paramArr[0] != paramKey) {
        arr.push(urlParamArr[i]);
      }
    }
  }
  if (arr.length > 0) {
    nextUrl = '?' + arr.join('&');
  }
  url = beforeUrl + nextUrl;
  return url;
}
/**
 * 格式化金额
 * @param {Number|String} num
 * return String
 */
export function priceFormat(num) {
  if (/\d$/.test(num.toString())) {
    return parseFloat(num)
      .toFixed(2)
      .toString();
  }

  return '';
}

export function getHourTime(date, period) {
  const time = date + ' ' + period.split('-')[1];
  return new Date(time).getTime();
}

export function plusZero(n) {
  return n < 10 ? '0' + n : n;
}

export function getNextDay(date) {
  const time = new Date(date).getTime() + 24 * 60 * 60 * 1000;
  const nextDay = new Date(time);
  const year = nextDay.getFullYear();
  const mouth = plusZero(nextDay.getMonth() + 1);
  const day = plusZero(nextDay.getDate());
  return `${year}-${mouth}-${day}`;
}

/**
 * 获取指定时间的时间戳
 * @param String 24:00:00
 * return Number
 */
export function convertTime(Deadline) {
  var nowDate = new Date();
  // 分割参数Deadline
  var _dateArr = Deadline.split(':');
  // 分别获取参数中对应的时、分、秒
  var hours = parseInt(_dateArr[0]);
  var minutes = parseInt(_dateArr[1]);
  var seconds = parseInt(_dateArr[2]);
  // 设置对应时分秒
  nowDate.setHours(hours);
  nowDate.setMinutes(minutes);
  nowDate.setSeconds(seconds);
  // 获取当前天中指定时分秒对应的毫秒数
  var result = Date.parse(nowDate);
  return result;
}

/**
 * 获取距离活动结束时间
 * @param String 2020-11-10T14:02:07
 * return String
 */
export function countTime(endTime) {
  var dd,
    hh,
    mm,
    ss = null;
  var time = new Date(endTime).getTime() - new Date().getTime();
  if (time <= 0) {
    return '';
  } else {
    dd = Math.floor(time / 1000 / 60 / 60 / 24);
    hh = Math.floor((time / 1000 / 60 / 60) % 24);
    mm = Math.floor((time / 1000 / 60) % 60);
    ss = Math.floor((time / 1000) % 60);
    dd = dd < 10 ? '0' + dd : dd;
    hh = hh < 10 ? '0' + hh : hh;
    mm = mm < 10 ? '0' + mm : mm;
    ss = ss < 10 ? '0' + ss : ss;
    var str =
      (dd > 0 ? dd + TLang('天', 'list') : '') + hh + ':' + mm + ':' + ss;
    return str;
  }
}

/**
 * 获取服务器时间
 * @param url 需要请求的服务器URL,为空默认取当前
 */
export function GetUrlTime(url) {
  console.log(url);
  // return new Promise<ResponseBasic>((resolve: (response: ResponseBasic) => void, reject: (errorResponse?: ResponseBasic) => void) => {
  //   let item: ResponseBasic = {
  //     Status: -1
  //   };
  //   try {
  //     let u = url || window.location.origin || process.env.BASIC_URL || '';
  //     let xhr = new XMLHttpRequest();
  //     xhr.open('HEAD', this.urlHandler(u), false);
  //     xhr.send(this.bodyHandler(null));
  //     item.Status = xhr.status;
  //     if (xhr.status === 200) {
  //       let serverDate = xhr.getResponseHeader('Date');
  //       if (serverDate) {
  //         let formaterDate = new Date(serverDate);
  //         let time = {
  //           year: formaterDate.getFullYear(),
  //           month: ('0' + (formaterDate.getMonth() + 1)).slice(-2),
  //           day: ('0' + (formaterDate.getDate())).slice(-2),
  //           hours: ('0' + (formaterDate.getHours())).slice(-2),
  //           minutes: ('0' + (formaterDate.getMinutes())).slice(-2),
  //           seconds: ('0' + (formaterDate.getSeconds())).slice(-2)
  //         };
  //         item.Data = time;
  //       }
  //       resolve(item);
  //     } else {
  //       reject(item);
  //     }
  //   } catch (e) {
  //     item.Message = e.message;
  //     reject(item);
  //   }
  // });
}

/**
 * 时间格式化
 * @param { date } date // 时间
 * @param { string } fmt  // 格式化格式
 * @return { String }  提示文案
 */
export function farmatDate(date, fmt) {
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds(),
  };
  let year = date.getFullYear().toString();
  year = year.length >= 4 ? year : '0000'.substr(0, 4 - year.length) + year;

  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (year + '').substr(4 - RegExp.$1.length));
  for (const k in o) {
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length),
      );
  }
  return fmt;
}

/**
 * 日期格式化
 * @param { date } date // 日期
 * @return { string } fmtDate  // 格式化日期
 */
export function formatDay(date) {
  let fmtDate = '';
  let mm = date.getMonth() + 1;
  mm = mm < 10 ? '0' + mm : mm;
  let dd = date.getDate();
  dd = dd < 10 ? '0' + dd : dd;
  let year = date.getFullYear();
  if (year != new Date().getFullYear()) {
    fmtDate =
      year +
      window.TLang('年', 'my') +
      mm +
      window.TLang('月', 'my') +
      dd +
      window.TLang('日', 'my');
  } else {
    fmtDate = mm + window.TLang('月', 'my') + dd + window.TLang('日', 'my');
  }
  return fmtDate;
}

/**
 * 错误收集器
 * @param key 标记
 * @param errorMessage 错误信息
 */
export function errorLog(page, key, errorMessage) {
  try {
    if (API_ENV === 'production') {
      const error = {
        page: page,
        error: `error - [${key}]`,
        data: errorMessage,
        timelog: new Date().toJSON(),
        cookies: document.cookie,
        localStorage: localStorage,
        sessionStorage: sessionStorage,
      };
      Sentry.withScope((scope) => {
        scope.setExtras(error);
        const eventId = Sentry.captureException(error);
      });
    }
  } catch (e) {
    console.log('error', e);
  }
}
/**
 * 时间戳转换成年月日
 * @param inputTime  时间戳
 * @returns yyyy-MM-dd HH-mm-ss
 */
export function formatDateTime(inputTime, type) { 
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute; 
  second = second < 10 ? ('0' + second) : second; 
  if(type === 'dot'){
    return y + '.' + m + '.' + d+' '+h+':'+minute+':'+second; 
  }
  return y + '-' + m + '-' + d+' '+h+':'+minute+':'+second; 
};

/**
 * 时间戳转换成年月日
 * @param prefixtime  时间戳
 * @param type ch 是否显示为年月日 dot ...
 * @param onlyShowDay  是否只显示年月日，不展示时分秒 默认false
 * @returns yyyy-MM-dd HH-mm-ss
 */
export function formatDayTime(prefixtime, type, onlyShowDay) {
  let inputTime = '' + prefixtime;
  inputTime = inputTime.replace(/-/g, '/').replace(/T/, ' ');
  var date = new Date(inputTime);
  var y = date.getFullYear();
  var m = date.getMonth() + 1;
  m = m < 10 ? '0' + m : m;
  var d = date.getDate();
  d = d < 10 ? '0' + d : d;
  var h = date.getHours();
  h = h < 10 ? '0' + h : h;
  var minute = date.getMinutes();
  var second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  let time = '';
  if (onlyShowDay) {
    time = '';
  } else {
    time = h + ':' + minute + ':' + second;
  }
  if(type === 'dot'){
    return y + '.' + m + '.' + d+' '+ time;
  } else if (type === 'ch') {
    return y + TLang('倒计时年', 'goods') + m + TLang('倒计时月', 'goods') + d + TLang('倒计时日', 'goods') + time;
  }
  return y + '-' + m + '-' + d +' '+ time;
}

/**
 * 遍历绑卡报错信息
 * 根据接口code
 * 重新赋值 1
 */
const errorMap = new Map([
  [122000, '绑卡失败'],
  [122001, '卡验证失败'],
  [122002, '卡已绑定'],
  [122003, '当前卡未设置指定卡规则'],
  [122004, '并发注册绑卡异常'],
  [122005, '卡号不匹配'],
  [122006, '卡未激活'],
  [122007, '卡预激活'],
  [122008, '卡已用完'],
  [122009, '卡已锁定，无法绑定'], // 1
  [122010, '卡券已过期，无法绑定'], // 1
  [122011, '非生日汇卡种不支持绑卡'],
  [122012, '抱歉该卡已被绑定'], // 1
  [122013, '重复操作'],
  [122014, '用户名或密码错误']
]);

// 处理绑卡显示
export function getMessageToCode(code, message = '') {
  return (errorMap.has(code) && errorMap.get(code)) || message;
}

/**
 * 构造会员中心权益接口所需入参
 */
export function getUserCenterParams(params = {}) {
  const secretKey = 'TQaXTvES';
  const _union = unionFlag() || sessionStorage.getItem('dffl_union');
  const _body = {
    sourceSys: _union ? 4 : 1, // 官网1，百福得4
    sourceWay: 2,
    ...params,
  };
  if (_union) {
    _body.union = _union;
  }
  let _params = {
    appId: '100037',
    msgId: '4ac05cd2-1ee2-409a-8f44-517bb10faadf',
    timestamp: +new Date(),
    version: '1.0.1',
    body: JSON.stringify({..._body}),
    sign: '',
  };
  _params.sign = sha(secretKey + _params.body + secretKey);
  return _params;
}


// 获取字符串时间
export function getDateStr(addDayCount = 0, today) {
  var dd;

  if (today) {
    dd = new Date(today);
  } else {
    dd = new Date();
  }

  dd.setDate(dd.getDate() + addDayCount); //获取AddDayCount天后的日期

  const y = dd.getFullYear();
  const m =
    dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1;
  const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate();
  return y + '-' + m + '-' + d;
}

// 获取时间戳
export function getTimestamp(addDayCount = 0, today) {
  var dd;

  if (today) {
    dd = new Date(today);
  } else {
    dd = new Date();
  }

  dd.setDate(dd.getDate() + addDayCount); //获取AddDayCount天后的日期

 return dd.getTime();
}

/**
 * 原来url上已经有众多qs参数，做融合，相同属性以传入的为准
 *
 * @param _url
 * @param queryObj
 * @returns
 *
 */
export function toQsPlus(_url, queryObj) {
  // url部分
  const tmpUrl = _url.split("?")[0];

  let obj = {};
  if (_url.split("?")[1]) {
    // url上的qs
    const tmpQsStr = _url.split("?")[1];

    // 将原url上的qs解析成对象
    const tmpQs = tmpQsStr
      .split("&")
      .map((v) => v.split("="))
      .map((v) => ({
        [v[0]]: v[1],
      }));
    tmpQs.forEach((v) => {
      obj = {
        ...obj,
        ...v,
      };
    });
  }
  // 原url上的qs与传入的融合，相同的属性，传入的覆盖之前的
  const newTmpQs = {
    ...obj,
    ...queryObj,
  };
  const keys = Object.keys(newTmpQs);
  const tmpStr = keys.map((v) => [v] + "=" + newTmpQs[v]);
  // 组合成新的url
  return tmpUrl + "?" + tmpStr.join("&");
}
